module.exports = __webpack_public_path__ + "img/ic_pin_s.34760db9.svg";